export const increaseGasLimit = (estimateGasResult: undefined | bigint) => {
  return estimateGasResult
    ? (estimateGasResult * BigInt(110)) / BigInt(100)
    : undefined;
};
